import { createRoute, redirect } from '@tanstack/react-router';
import { Route as pathlessAuthenticatedRoute } from '../../route';

/** Supplier Portals was renamed Vendor Portals; keep old links and bookmarks working. */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/pricing/supplier-portals',
  beforeLoad: () => {
    throw redirect({ to: '/pricing/vendor-portals' });
  },
});
